import { Icon } from "@/components/atoms";
import { useBookingViewOnly } from "../BookingViewOnlyContext";

/**
 * The standard Booking Summary "edit this step" affordance — a large Edit2 pencil that jumps the
 * user back to the step. Shared by the draft-step summary (BookingSummaryPanel) and the priced
 * Payment-step cards (SummaryCard) so the affordance can't drift between the two variants.
 *
 * In view-only (a closed booking) it becomes an eye: the boxes still let you jump between steps to
 * review each section, but nothing is editable — so the icon shouldn't imply editing.
 */
export const EditPencil = ({ label, onClick }: { label: string; onClick: () => void }) => {
  const viewOnly = useBookingViewOnly();
  return (
    <button
      type="button"
      aria-label={viewOnly ? label.replace(/^Edit/i, "View") : label}
      onClick={onClick}
      className="shrink-0 text-neutral-dark-gray hover:text-primary"
    >
      <Icon name={viewOnly ? "Eye" : "Edit2"} size="lg" />
    </button>
  );
};
